import { TEMPLATE_TYPES, type TemplateType } from '@cls-nordic/pdf-templates/browser';

import { RCertificateTemplateType } from '@/store/v2';

/**
 * Maps the GraphQL template type to the pdf-templates library template id.
 *
 * Kept separate from the template metadata so that consumers which only need the template
 * list (e.g. the picker) don't pull the pdf-templates / react-pdf runtime into their bundle.
 */
export const getPdfTemplateId = (templateType: RCertificateTemplateType): TemplateType =>
  templateType === RCertificateTemplateType.Classic ? TEMPLATE_TYPES.CLASSIC : TEMPLATE_TYPES.PROFESSIONAL;
